import type { ReactiveVars } from '../../../..';

export default function createCloseAllDrawers(drawersVar: ReactiveVars['drawersVar']) {
  return (): void => {
    const drawers = drawersVar();

    drawersVar(drawers.map((drawer) => ({
      ...drawer,
      visible: false,
    })));
  };
}
